import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import {
  ArrowRightSquareFill,
  ArrowLeftSquareFill
} from "react-bootstrap-icons";
import "./styles.css";
const ScreenShotsModal = ({ show, setShow, links, setLinks }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleClose = () => {
    setShow(false);
    setLinks([]);
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % links.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? links.length - 1 : prevIndex - 1
    );
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>
          Snapshots -
          {links[currentIndex]
            ?.split("/")[6]
            ?.split(".mp4")[0]
            ?.replace("_", " ")
            .replace(/%3A/g, ":")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="custom-carousel">
          <div className="carousel-content">
            {links[currentIndex]?.includes("mp4") ? (
              <video
                key={links[currentIndex]} // Force re-render when the source changes
                controls
                className="d-block"
                style={{ width: "100%" }}
                loading="lazy"
              >
                <source src={links[currentIndex]} type="video/mp4" />
              </video>
            ) : (
              <img
                src={links[currentIndex]}
                alt={`Slide ${currentIndex + 1}`}
                className="d-block w-100"
                loading="lazy"
              />
            )}
          </div>
          <div className="carousel-controls">
            <button onClick={prevSlide}>
              <ArrowLeftSquareFill size={40} fill="blue" />
            </button>
            <button onClick={nextSlide}>
              <ArrowRightSquareFill size={40} fill="blue" />
            </button>
          </div>
          <div className="carousel-indicator">
            {links.map((_, index) => (
              <span
                key={index}
                className={`indicator-dot ${
                  index === currentIndex ? "active" : ""
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ScreenShotsModal;
